export default {"src":"/_next/static/media/stats_dots.d8fadae3.svg","height":429,"width":392,"blurWidth":0,"blurHeight":0};